import React from "react";
import {
  Button,
  FormFieldSet,
  PageTitle,
  StatusTags,
  TableAdv,
} from "../../../../../../components";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";

const Transactions = () => {

  const { userData: loginUserData } = useLoginUser();

  const STATUS_MAP = {
    1: "Paid",
    2: "Blocked",
  };
  const rows = [
    {
      slno: 1,
      InvoiceRef: 1367564523,
      Status: 1,
      SubTotal: "Subscription top-up through techfive portal",
      SubTotals: 193.0,
      Discount: 0.0,
    },
    {
      slno: 1,
      InvoiceRef: 1367564523,
      Status: 1,
      SubTotal: "Subscription top-up through techfive portal",
      SubTotals: 193.0,
      Discount: 0.0,
    },
    {
      slno: 1,
      InvoiceRef: 1367564523,
      Status: 1,
      SubTotal: "Subscription top-up through techfive portal",
      SubTotals: 193.0,
      Discount: 0.0,
    },
    {
      slno: 1,
      InvoiceRef: 1367564523,
      Status: 1,
      SubTotal: "Subscription top-up through techfive portal",
      SubTotals: 193.0,
      Discount: 0.0,
    },
    {
      slno: 1,
      InvoiceRef: 1367564523,
      Status: 1,
      SubTotal: "Subscription top-up through techfive portal",
      SubTotals: 193.0,
      Discount: 0.0,
    },
    {
      slno: 1,
      InvoiceRef: 1367564523,
      Status: 1,
      SubTotal: "Subscription top-up through techfive portal",
      SubTotals: 193.0,
      Discount: 0.0,
    },
    {
      slno: 1,
      InvoiceRef: 1367564523,
      Status: 1,
      SubTotal: "Subscription top-up through techfive portal",
      SubTotals: 193.0,
      Discount: 0.0,
    },
  ];
  const columns = [
    {
      key: "InvoiceRef",
      label: "Invoice Ref#",
      minWidth: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.InvoiceRef}</div>
      ),
    },
    {
      key: "Status",
      label: "Status",
      width: 250,
      render: (row) => (
        <StatusTags
          tag={STATUS_MAP[row?.Status] || "-"}
          variant="contained"
          className="bg-success-100"
        />
      ),
    },
    {
      key: "SubTotal",
      label: "Sub Total",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.SubTotal}</div>
      ),
    },
    {
      key: "SubTotals",
      label: "Sub Total",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.SubTotals}</div>
      ),
    },
    {
      key: "Discount",
      label: "Discount",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.Discount}</div>
      ),
    },
  ];
  return (
    loginUserData?.role?.module===4?
    <div className="flex flex-col justify-center items-center flex-1 overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          Transactions
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>
    :
    
       <div className="p-2 flex flex-col h-full overflow-hidden w-full">
      <PageTitle title={"Take Invoice & Refund"} tag="h5" />
      <div className="text-neutrals-500 text-sm mt-1">
        Monitor your Invoices, view previous payments & receipts here
      </div>
      <div className="flex-grow mt-4 w-full flex flex-col overflow-hidden" style={{ height: "calc(100vh - 340px)", minHeight: "300px" }}>
        <TableAdv
          columns={columns}
          showSlNo
          rows={rows}
          toolbarRight={{
            search: true,
            add: [
              {
                component: (
                  <FormFieldSet
                    noTitle
                    size="sm"
                    type="select"
                    placeholder="Select Invoices"
                  />
                ),
              },
            ],
          }}
        />
      </div>
    </div>
    )
};

export default Transactions;
